// T-181 — page « Tableau de bord » du tenant : la grille de widgets du hub `tableau_bord`.
// L'accès est gardé deux fois : menu (capacité `management.tableau_bord`, lecture stricte) ET route serveur (fail-closed, admin).
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function TableauBordPage() {
  return <DashboardGrid hub="tableau_bord" title="Tableau de bord" />;
}
